import { IInvitationRepository } from '../../application/ports/outbound/IInvitationRepository';
import { SendInvitationResult } from '../../application/domain/entities/SendInvitationResult';
import { SendInvitationInput } from '../../application/domain/entities/SendInvitationInput';
import { SendInvitationRequestDto } from './dto/req/SendInvitationRequestDto';
import { SendInvitationResponseDto } from './dto/res/SendInvitationResponseDto';
import { InvitationLocationItemDto } from './dto/res/InvitationLocationItemDto';
import { mapSendInvitationResponseToEntity } from './mappers/invitationMapper';
import { mapInvitationLocationDtoToEntity } from './mappers/invitationLocationMapper';
import { HttpClient } from '@/shared/infra/http/HttpClient';
import { InvitationLocationItem } from '../../application/domain/entities/InvitationLocationItem';

export class ApiInvitationRepository implements IInvitationRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async getLocations(): Promise<InvitationLocationItem[]> {
    const response =
      await this.httpClient.get<InvitationLocationItemDto[]>('/location/employer-locations');
    if (!Array.isArray(response?.data)) {
      throw new Error('Invalid invitation locations response');
    }

    return response.data.map(mapInvitationLocationDtoToEntity);
  }

  async sendInvitation(input: SendInvitationInput): Promise<SendInvitationResult> {
    try {
      const request: SendInvitationRequestDto = {
        firstName: input.firstName,
        lastName: input.lastName,
        email: input.email,
        locationId: input.locationId,
        ssn: input.ssn,
        hireDate: input.hireDate,
        confirmDuplicate: input.confirmDuplicate,
      };
      const response = await this.httpClient.post<SendInvitationResponseDto>(
        '/invitation/send',
        request
      );
      // HttpClient returns ApiResponse<T>, need to access .data
      return mapSendInvitationResponseToEntity(response.data);
    } catch (error) {
      console.error('Error sending invitation:', error);
      throw error;
    }
  }
}
